<div class="h-100 overflow-auto">
    <div class="container-sm-fluid pt-3 px-sm-4">
        @if (tabs.length > 1) {
            <dx-tabs
                keyExpr="key"
                [items]="tabs"
                [selectedItemKeys]="[selectedTab]"
                [showNavButtons]="false"
                stylingMode="primary"
                class="mb-2"
                (onItemClick)="selectedTab = $event.itemData.key"></dx-tabs>
        }
    </div>

    @if (selectedTab === 'yardCapacity' && showYardCapacity) {
        <app-yard-capacity-score></app-yard-capacity-score>
    } @else if (selectedTab === 'emptyTrailerAging' && showEmptyTrailerAging) {
        <app-empty-trailer-score></app-empty-trailer-score>
    } @else if (selectedTab === 'shuntProductivity' && showShuntProductivity) {
        <app-shunt-productivity-score></app-shunt-productivity-score>
    }
</div>
